import Vue from 'vue';
import App from './App.vue';
import Env from '@/env';
import bus from '@/bus';
import store from './store';
import router from '@/middlewares/index';
import * as VueGoogleMaps from 'vue2-google-maps';
import '@fortawesome/fontawesome-free/css/all.css';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import '@/assets/css/styles.css';
import VueGoodTablePlugin from 'vue-good-table';
import {mixin} from './mixins';
import VueConfirmDialog from '@/plugins/vue-confirm-dialog/index.js';
import Toasted from 'vue-toasted';
// import the styles
import 'vue-good-table/dist/vue-good-table.css';

import PubNubVue from 'pubnub-vue';
Vue.use(PubNubVue, {subscribeKey: 'sub-c-eb5bb942-af3e-11eb-aad1-021b9ca2091c', publishKey: 'pub-c-9f22dca4-63b6-4f15-b05b-9f389d986a99'});

//Vue.use(Toasted, Options)
Vue.use(Toasted, {
    iconPack: '',
    position: 'bottom-center',
    duration: 3000,
    theme: 'outline',
    singleton: true,
    action: {
        text: 'Close',
        onClick: (e, toastObject) => {
            toastObject.goAway(0);
        }
    }
});

Vue.toasted.register(
    'error',
    payload => {
        if (!payload.message) {
            return 'Oops.. Something Went Wrong..';
        }
        return payload.message;
    },
    {
        type: 'error',
        // icon : 'times',
        duration: 5000
    }
);

Vue.toasted.register(
    'success',
    payload => {
        if (!payload.message) {
            return 'Successful..';
        }
        return payload.message;
    },
    {
        type: 'success'
        // icon : 'check'
    }
);

Vue.use(VueConfirmDialog);
Vue.component('vue-confirm-dialog', VueConfirmDialog.default);

import VTooltip from 'v-tooltip';
Vue.use(VTooltip);

const _ = require('lodash');
Vue.mixin(mixin);
Vue.use(VueGoodTablePlugin);
Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBxYoScqo2iRghOZ3_NvmXMvYsQXzSrgW8',
        libraries: 'places'
    }
});

window.bus = bus;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
